import { render, staticRenderFns } from "./SGEventos2.vue?vue&type=template&id=d3c6dce8&scoped=true"
import script from "./SGEventos2.vue?vue&type=script&lang=js"
export * from "./SGEventos2.vue?vue&type=script&lang=js"
import style0 from "./SGEventos2.vue?vue&type=style&index=0&id=d3c6dce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c6dce8",
  null
  
)

export default component.exports